import { Grid } from 'antd';

export interface Responsive {
  isMobile: boolean;
  isTablet: boolean;
}

/**
 * Screen-size helper built on top of Ant Design's grid breakpoints.
 * - mobile: width < 768px (below `md`)
 * - tablet: 768px – 991px (`md` and below `lg`)
 */
export function useResponsive(): Responsive {
  const screens = Grid.useBreakpoint();

  const isMobile = !screens.md;
  const isTablet = !!screens.md && !screens.lg;

  return { isMobile, isTablet };
}
